import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument} from "@js/helpers.ts";
import axios from "axios";

const formDefaultData = {
    product: null,
    bitrix_title: 'Быстрый заказ',
    data: {
        full_name: '',
        phone: '',
        captcha_token: '',
    },
    isOpen: false,
    errors: [],
    animation_in_progress: false,
    sending: false,
    successfully_sent: false,
}
export const useProductStore = defineStore('productStore', {
    state: () => ({
        product: {
            price: null,
        },
        images: null,
        characteristics_grouped: null,
        callback: {...formDefaultData}
    }),
    actions: {
        sendPopupForm() {
            if (!checkDocument()) return;

            this.callback.errors = []
            this.callback.sending = false
            this.callback.data.captcha_token = ''
            this.callback.successfully_sent = false

            const captchaId = 'smart-captcha-container-base-callback'

            // 1. Удаляем предыдущий контейнер и сбрасываем предыдущую капчу
            const existingContainer = document.getElementById(captchaId)
            if (existingContainer) {
                try {
                    // Пытаемся уничтожить по id (если это был widgetId)
                    window.smartCaptcha.destroy(existingContainer.dataset.widgetId)
                } catch (e) {
                }
                existingContainer.remove()
            }

            // 2. Создаём новый контейнер
            const container = document.createElement('div')
            container.id = captchaId
            container.style.position = 'absolute'
            container.style.zIndex = '-1'
            document.body.appendChild(container)

            let tokenReceived = false

            // 3. Рендерим капчу и сохраняем widgetId
            const widgetId = window.smartCaptcha.render(captchaId, {
                sitekey: import.meta.env.VITE_YANDEX_SMARTCAPTCHA_SECRET,
                invisible: true,
                hideShield: true,
                callback: (token) => {
                    tokenReceived = true
                    this.callback.sending = true
                    this.callback.data.captcha_token = token

                    axios.post('/axios/form/send-lead', {
                        bitrix_title: this.callback.bitrix_title,
                        ...this.callback.data,
                        cart_products: [this.callback.product],
                    }).then(() => {
                        this.callback.sending = false
                        this.callback.successfully_sent = true
                        this.callback.data.captcha_token = ''

                        try {
                            window.smartCaptcha.destroy(widgetId)
                        } catch (e) {
                        }
                    }).catch(error => {
                        this.callback.sending = false
                        if (error.response?.status === 422) {
                            this.callback.errors = error.response.data.errors
                        }
                    })
                }
            })

            // Привязываем widgetId к контейнеру для возможного удаления позже
            document.getElementById(captchaId).dataset.widgetId = widgetId

            // 4. Обработка закрытия пользователем (✕)
            window.smartCaptcha.subscribe(widgetId, 'challenge-hidden', () => {
                if (!tokenReceived) {
                    this.callback.sending = false
                    this.callback.errors = {
                        captcha_token: ['Вы закрыли капчу. Повторите попытку.']
                    }

                    try {
                        window.smartCaptcha.reset(widgetId)
                    } catch (e) {
                    }
                }
            })

            // 5. Запуск
            setTimeout(() => {
                try {
                    window.smartCaptcha.execute(widgetId)
                } catch (e) {
                    this.callback.sending = false
                    this.callback.errors = {
                        captcha_token: ['Не удалось запустить капчу. Попробуйте ещё раз.']
                    }
                }
            }, 100)
        },
        showFastBuyPopup(id) {
            let vm = this

            axios.post('/axios/products/get-by-id', {
                id: id,
            }).then(response => {
                this.callback.product = response.data

                const themeStore = useThemeStore()
                themeStore.setBodyOverflow(true)
                this.callback.animation_in_progress = false
                this.callback.isOpen = true
                this.callback.successfully_sent = false

                setTimeout(function () {
                    vm.callback.animation_in_progress = true
                }, 50)
            })
        },
        closeFastBuyPopup() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(false)
            this.callback = {...formDefaultData}

            let vm = this
            setTimeout(function () {
                vm.callback.isOpen = false
                vm.callback.animation_in_progress = true
            }, 500)
        },
    }
});
